import { render } from "./what-attachments.vue?vue&type=template&id=5e1ef59d&lang=pug"
import script from "./what-attachments.vue?vue&type=script&setup=true&lang=js"
export * from "./what-attachments.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__